
import { defineComponent } from 'vue';

import BasicButton from '@hems/component/src/buttons/BasicButton.vue';
import ContentModal from '@hems/component/src/modal/ContentModal.vue';
import { BASIC_BUTTON_COLOR_TYPE } from '@hems/util/src/constant/button';

export default defineComponent({
  name: 'IdleTimePopup',
  components: {
    ContentModal,
    BasicButton,
  },
  emits: ['confirm', 'close'],
  setup(_props, { emit }) {
    const close = () => {
      emit('close');
    };

    const confirm = () => {
      emit('confirm');
    };

    return {
      confirm,
      close,
      BASIC_BUTTON_COLOR_TYPE,
    };
  },
});
